import React from 'react';
import { Tooltip } from 'antd';
import cn from 'classnames';
import ImportantIndicatorToggle from '../ImportantIndicatorToggle/ImportantIndicatorToggle';
import styles from './QuestionMeta.module.scss';

const QuestionMeta = ({
  question,
  className,
  renderTitle,
  hasImportantToggle = false,
  hideInactiveImportantIndicator = true,
  importantToggleClass,
  showActions = true,
}) => {
  const { type, typeId } = question || {};

  return (
    <div className={cn(styles.root, className)}>
      <Tooltip title={type}>
        <img width={45} height={45} src={`/img/qt/${typeId}.svg`} alt={type} />
      </Tooltip>
      <div className={styles.titleWrap}>
        <h4 className={styles.title}>
          {typeof renderTitle === 'function'
            ? renderTitle(question.fullAddress)
            : question.fullAddress}
        </h4>
        <span className={styles.company}>{question.serviceCompany}</span>
      </div>
      {showActions && (
        <div className={styles.actions}>
          <ImportantIndicatorToggle
            isToggle={hasImportantToggle}
            hideInactiveIndicator={hideInactiveImportantIndicator}
            question={question}
            toggleClass={importantToggleClass}
          />
        </div>
      )}
    </div>
  );
};

export default QuestionMeta;
